import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-lg bg-stone-200/60',
        'bg-[length:400%_100%]',
        'bg-gradient-to-r from-stone-200/60 via-stone-100/60 to-stone-200/60',
        'animate-[shimmer_1.5s_ease-in-out_infinite]',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
